module.exports = __webpack_public_path__ + "img/foto_1.8e0a6794.png";